import clsx from 'clsx';
import {SanityTeamMember} from '~/types/sanityTypes';
import urlBuilder from '@sanity/image-url';
import {useSanityClient} from '~/lib/utils';

export function TeamMemberCard({
  teamMember,
  className,
}: {
  teamMember: SanityTeamMember;
  className?: string;
}) {
  const styles = clsx('relative grid', className);

  return (
    <div className={styles}>
      <div className="w-full aspect-[322/480] overflow-hidden">
        <img
          src={urlBuilder(useSanityClient)
            .image(teamMember.image)
            .width(1200)
            .fit('max')
            .auto('format')
            .url()}
          alt={teamMember.name + ' kuva'}
          loading="lazy"
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
            height: '100%',
            width: '100%',
          }}
        />
      </div>
      <div className="w-full md:absolute md:bottom-0">
        <div className="bg-white my-4 md:m-4 md:p-4">
          <h3 className="font-clash text-base mb-1 mt-0">{teamMember.name}</h3>
          <span className="block mt-1 text-xs break-words">
            <a href={'email:' + teamMember.email}>{teamMember.email}</a>
          </span>
          <span className="block mt-1 text-xs">
            <a href={'tel:' + teamMember.phone}>{teamMember.phone}</a>
          </span>
          <span className="block mt-4 text-[12px] uppercase tracking-[0.05em]">
            {teamMember.specialities}
          </span>
        </div>
      </div>
    </div>
  );
}
